// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slide-enter-active[data-v-592bc2ee],.slide-leave-active[data-v-592bc2ee]{top:64px;transition:all .5s}.slide-enter[data-v-592bc2ee],.slide-leave-to[data-v-592bc2ee]{opacity:0;top:-64px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
